<template>
  <div class="home">
    <div class="container is-fluid">
      <page-header :entity="$entitiesName.Vat" :create="openCreateModal">
        <h1 class="title">{{ $t("entities.vats") }}</h1>
      </page-header>

      <datatable
        ref="vatTable"
        :fetch="$api.fetchVatsPage"
        :enableDownload="false"
        objectName="vat"
        identifier="name"
      >
        <div
          slot="name"
          slot-scope="{ item }"
          :title="$t('common.name')"
          :sortable="true"
        >
          {{ item.name }}
        </div>
        <div
          slot="amount"
          slot-scope="{ item }"
          :title="$t('vats.amount')"
          :sortable="true"
        >
          {{ item.amount }}
        </div>
        <div
          slot="reversedCharge"
          slot-scope="{ item }"
          :title="$t('markets.vatTypes.reverseCharge')"
          :sortable="true"
          nofilter
        >
          <field isCheckbox :isChecked="item.reversedCharge" />
        </div>
        <div
          slot="oracleCode"
          slot-scope="{ item }"
          :title="$t('common.oracleCode')"
          :sortable="true"
        >
          {{ item.oracleCode }}
        </div>
        <div slot="actions" slot-scope="{ item }">
          <router-link :to="'/vat/' + item.id" class="button is-primary">
            <i class="fa fa-search"></i>
          </router-link>
        </div>
      </datatable>

      <modal
        ref="createVatModal"
        @close="resetPrototype"
        @create="createVat"
        :title="$t('vats.creation')"
      >
        <div class="columns">
          <div class="column is-half">
            <text-field
              cy-data="vat-name"
              :label="$t('common.name')"
              v-model="prototypeVat.name"
              :inline="false"
              :edit="true"
              required
            />
            <numeric-field
              cy-data="vat-amount"
              :label="$t('vats.amount')"
              v-model="prototypeVat.amount"
              :inline="false"
              :edit="true"
              required
              min="0"
              step="0.01"
            />
            <checkbox-field
              cy-data="vat-reversed"
              :label="$t('markets.vatTypes.reverseCharge')"
              v-model="prototypeVat.reversedCharge"
              :edit="true"
              :inline="false"
            />
            <text-field
              cy-data="vat-oracle"
              :label="$t('common.oracleCode')"
              v-model="prototypeVat.oracleCode"
              :inline="false"
              :edit="true"
            />
          </div>
        </div>
      </modal>
    </div>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "VatList",
  data() {
    return {
      prototypeVat: {
        name: "",
        amount: null,
        reversedCharge: false,
        oracleCode: "",
      },
    };
  },
  methods: {
    openCreateModal() {
      this.$refs.createVatModal.open();
    },
    resetPrototype() {
      this.prototypeVat = {
        name: "",
        amount: null,
        reversedCharge: false,
        oracleCode: "",
      };
    },
    createVat() {
      this.$validator.validateAll().then((result) => {
        if (!result) {
          return;
        }
        const body = {
          name: this.prototypeVat.name,
          amount: this.prototypeVat.amount,
          reversedCharge: !!this.prototypeVat.reversedCharge,
          oracleCode: this.prototypeVat.oracleCode || null,
        };
        axios.post("/vat", body).then((res) => {
          this.$refs.createVatModal.close();
          this.resetPrototype();
          this.$refs.vatTable.refresh();
          if (res.data && res.data.id) {
            this.$router.push({
              name: "Vat",
              params: { id: res.data.id },
            });
          }
        });
      });
    },
  },
};
</script>
